import { Routes } from "@angular/router";
import { chatScopeTransitionGuard } from "@app/shared/general/chat/guards/chat-scope-transition.guard";
import { mentionDiscussionAccessResolver } from "@app/shared/general/mention-discussion/resolvers/mention-discussion-access.resolver";
import { resourceChatLeaveGuard, resourceChatLinkResolver } from "@app/shared/general/resource-chat";

export const chatRoutes: Routes = [
  {
    path: "discussions/:resourceName/:resourceId/:messageId",
    loadComponent: () => import("./pages/mention-discussion-page/mention-discussion-page.component").then(m => m.MentionDiscussionPageComponent),
    canActivate: [chatScopeTransitionGuard],
    canDeactivate: [resourceChatLeaveGuard],
    runGuardsAndResolvers: "always",
    resolve: { entry: mentionDiscussionAccessResolver },
  },
  // The link every mention email carries. The owning service decides where the
  // viewer goes: the resource view with the message, or the message's
  // discussion. Only an unknown link or a failed check is shown here, so this
  // route never hosts a chat and needs none of the discussion route's chat guards.
  {
    path: "messages/:resourceName/:resourceId/:messageId",
    loadComponent: () => import("./pages/mention-discussion-page/mention-discussion-page.component").then(m => m.MentionDiscussionPageComponent),
    runGuardsAndResolvers: "always",
    resolve: { entry: resourceChatLinkResolver },
  },
];
